import { useMemo } from 'react';
import { parseLogEventsMessage } from 'automation-ui-log-events/utils/messageParser';
import { jsx as _jsx } from "react/jsx-runtime";
const DynamicLogEventMessage = ({
  logEvent
}) => {
  const userFacingMessage = useMemo(() => parseLogEventsMessage(logEvent.portalId, logEvent.logEventMessage), [logEvent.portalId, logEvent.logEventMessage]);
  return /*#__PURE__*/_jsx("div", {
    children: userFacingMessage
  });
};
export default DynamicLogEventMessage;